<div class="meter-request-card">
  <div class="meter-request-header">
    <label class="section-label">{{'METER_REQUEST.TITLE' | translate}}</label>
    <span class="count-badge">{{ relatedAccounts?.length || 0 }}</span>
  </div>
  <div class="meter-request-table">
    <div class="row table-header-row">
      <div class="col-3">{{'METER_REQUEST.SERVICE_ORDER_ID' | translate}}</div>
      <div class="col-3">{{'METER_REQUEST.ACCOUNT_NUMBER' | translate}}</div>
      <div class="col-3">{{'METER_REQUEST.SPN' | translate}}</div>
      <div class="col-3">{{'METER_REQUEST.PHASE_REQUESTED' | translate}}</div>
    </div>
    <div class="row table-data-row" *ngFor="let account of relatedAccounts">
      <div class="col-3">{{ account.serviceOrderId | hasValue }}</div>
      <div class="col-3">{{ account.accountNumber | hasValue }}</div>
      <div class="col-3">{{ account.spn | hasValue }}</div>
      <div class="col-3 phase-view-cell">
        <span>{{ account.phaseRequested | hasValue }}</span>
        <button
          type="button"
          class="btn btn-outline-dark view-btn"
          (click)="viewAccount(account)"
        >
          {{'METER_REQUEST.VIEW' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<app-service-request-history-modal
  [visible]="isHistoryModalVisible"
  [relatedAccountId]="selectedRelatedAccountId"
  [history]="selectedHistory"
  (closed)="closeHistoryModal()"
></app-service-request-history-modal>
